import React,{useEffect,useState,useCallback} from 'react'
import {Routes, Route,useNavigate,useLocation, Link} from 'react-router-dom';
import Logo from '../../assets/images/logo.png'
import routes from '../../routes';
import Header from '../../components/common/Header';
import { getUserProfileDetail,getCountryCode, getStudentFee } from '../../actions/StudentAction';
import { StateUseContext } from '../../context/UserDetailContext';
import swal from 'sweetalert';

const Student = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {userDetail,setUserDetail,setCountryCode,setFeeDetail,setFeeLoader,country_code,PageLoader,setPageLoader} = StateUseContext();
    const {country_id} = userDetail !==undefined && userDetail
    const userFind = sessionStorage.getItem("token");

    // Extract Clarity tracking to a separate function
    const setupClarityTracking = useCallback(() => {
        if (window.clarity && userDetail?.form_num && userDetail?.name) {
            window.clarity("set", "page_view", location.pathname);
            window.clarity("set","form_number", String(userDetail?.form_num));
            window.clarity("set","user_name",String(userDetail?.name));
        }
    }, [location.pathname, userDetail]);

    // Check authentication and setup context menu
    useEffect(() => {
        if(!userFind){
            navigate('/login');
            return;
        }

        const handleContextMenu = (e) => {
            e.preventDefault();
        };
      
        document.addEventListener('contextmenu', handleContextMenu);
        
        const userProfileDetail = async() => {
            try {
                const res = await getUserProfileDetail();
                if(res.status){
                    setUserDetail(res !==undefined && res.data);
                    setPageLoader(false);
                } else {
                    swal('Session is Expired! Please login again','','error');
                    sessionStorage.clear();
                    navigate('/login');
                }
            } catch (error) {
                console.error('Error fetching user profile:', error);
                swal('Error', 'Failed to load user profile. Please try again.', 'error');
            }
        };

        userProfileDetail();

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
        };
    }, [location.pathname, userFind, navigate, setUserDetail, setPageLoader]);

    // Fetch country code and student fee data
    useEffect(() => {
        if (!userDetail || !userFind) {
            navigate('/login');
            return;
        }

        let isMounted = true;

        const countryCode = async() => {
            try {
                const res = await getCountryCode(country_id);
                if(res.status && isMounted){
                    const staticData = {
                        id: 10,
                        isd_code: "+91",
                        iso_code: "IN"
                    };
                    const updatedOptions = [...res?.data, staticData];
                    setCountryCode(updatedOptions);
                }
            } catch (error) {
                console.error('Error fetching country code:', error);
            }
        };

        const studentFeeData = async() => {
            try {
                const res = await getStudentFee(userDetail?.id);
                if(isMounted) {
                    setFeeLoader(false);
                    if(res.status){
                        setFeeDetail(res.data);
                    }
                }
            } catch (error) {
                console.error('Error fetching student fee:', error);
                if(isMounted) {
                    setFeeLoader(false);
                }
            }
        };

        studentFeeData();
        countryCode();

        return () => {
            isMounted = false;
        };
    }, [userDetail?.country_id, userDetail?.id, userDetail?.course_name, userDetail?.center_name, location.pathname, userFind, navigate, setCountryCode, setFeeDetail, setFeeLoader]);

    // Setup Clarity tracking
    useEffect(() => {
        setupClarityTracking();
    }, [setupClarityTracking]);

    const getRoutes = (routes) => {
        return routes.map((prop,key) => {
            if(prop.layout ==='/student'){
                return(
                    <React.Fragment key={key}>
                    <Route  path={prop.path} element={prop.component}  />
                    {/* <Route  path='*' key={12} element={()=>{
                       
                        return (
                        <div className='page_not_found'>
                        <h1 className='text-center'>404</h1>
                        <p>Page not found</p>
                        <Link to={'dashboard'} className='btn btn-primary'>Return to Dashboard</Link>
                        </div>
                        )
                    }}/> */}
                      </React.Fragment>
                )
            }
            else{
                return null;
            }
        })
    }
  return (
    PageLoader ? <div className="pageLoader">
        <img src={Logo} alt="Logo" style={{height:'60px',display:'block'}} />
       {/* <p>Loading...</p>  */}
        </div> :
    <>
    <Header/>
    <div>
        <Routes>
            {getRoutes(routes)}
        </Routes>
        
    </div>
    </>

  )
}

export default Student